import React from "react";
import "./DeviceSignalCard.css";
import { titles } from "constants/titles";
import {
  getBatteryIcon,
  getSignalIcon,
  getSignalType,
} from "utility/deviceDetailUtils";

const DeviceSignalCard = ({ statusUpdateAt, className, deviceInfo, type }) => {
  return (
    <div className={`dsc_card ${className}`}>
      {/* Battery Status Section */}
      <div className="dsc_status_row">
        <div className="dsc_status_container">
          <div className="dsc_status_icon">
            {getBatteryIcon(deviceInfo?.batteryLife)}
          </div>
          <div className="dsc_status_info">
            <h4 className="dsc_status_title">{titles?.battery_life}</h4>
            {statusUpdateAt && (
              <p className="dsc_status_timestamp">{statusUpdateAt}</p>
            )}
          </div>
        </div>
        <div className="dsc_status_value">
          {deviceInfo?.batteryLife != null || deviceInfo?.batteryLife !== undefined
            ? `${deviceInfo?.batteryLife}%`
            : "Unknown"}
        </div>
      </div>

      {/* Signal Status Section (only for non-Anelto devices) */}
      {type !== "anelto" && (
        <>
          <div className="dsc_separator"></div>
          <div className="dsc_status_row">
            <div className="dsc_status_container">
              <div className="dsc_status_icon">
                {getSignalIcon(deviceInfo?.signal_strength)}
              </div>
              <div className="dsc_status_info">
                <h4 className="dsc_status_title">{titles?.signal_strength}</h4>
                {statusUpdateAt && (
                  <p className="dsc_status_timestamp">{statusUpdateAt}</p>
                )}
              </div>
            </div>
            <div className="display_h4 dsc_status_value_color">
              {getSignalType(deviceInfo?.signal_strength)}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DeviceSignalCard;
